import {UAParser} from 'ua-parser-js';

const parser = new UAParser();
parser.setUA(navigator.userAgent);
const device = parser.getDevice();

export function isMobile(): boolean {
  return device.type === 'mobile';
}
